import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store.js'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom';
import ComponentErrorBoundary from "./BugsnagErrorReporting.jsx";
import { ThemeProvider } from './design_system/theming/ThemeContext.jsx';
import { ToastProvider } from './design_system/components/Toast/ToastContext.jsx';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './queries/queryClient';
import { isDevelopment } from './configurations/env_config';
import TeamSwitchPopup from './teamContext/TeamSwitchPopup';
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <App /> */}
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ComponentErrorBoundary>
            <ThemeProvider>
              <ToastProvider>
                <TeamSwitchPopup />
                <App />
              </ToastProvider>
            </ThemeProvider>
          </ComponentErrorBoundary>
          {isDevelopment && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
